import HeaderBar from "./components/headerBar";
import {
  MessageSquare,
  Code2,
  Users2,
  ExternalLink,
  Zap,
  ShieldCheck,
  Globe
} from "lucide-react";
import Button from "../../components/common/Button";

const FeatureCard = ({ icon: Icon, title, description, colorClass, href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="cht-group cht-p-8 cht-bg-white cht-rounded-[32px] cht-shadow-[0_10px_30px_rgba(0,0,0,0.02)] cht-border cht-border-gray-50 hover:cht-border-[#3e57da]/20 hover:cht-shadow-2xl hover:-cht-translate-y-1 cht-transition-all cht-duration-500 cht-text-left cht-no-underline cht-block"
  >
    <div className={`cht-w-14 cht-h-14 cht-rounded-[20px] ${colorClass} cht-flex cht-items-center cht-justify-center cht-mb-6 cht-shadow-lg group-hover:cht-scale-110 cht-transition-transform`}>
      <Icon size={28} className="cht-text-white" />
    </div>
    <h3 className="cht-text-xl cht-font-black cht-text-black cht-mb-2 group-hover:cht-text-[#3e57da] cht-transition-colors">{title}</h3>
    <p className="cht-text-sm cht-text-gray-400 cht-font-medium cht-leading-relaxed">{description}</p>
    <div className="cht-mt-6 cht-flex cht-items-center cht-gap-2 cht-text-[#3e57da] cht-text-xs cht-font-bold cht-opacity-0 group-hover:cht-opacity-100 cht-transition-all">
      Join Channel <ExternalLink size={14} />
    </div>
  </a>
);

const CommunityHub = () => {
  return (
    <section className="cht-animate-in cht-fade-in cht-duration-700">
      <HeaderBar pageHeader="Community Hub" />

      <main className="cht-container cht-space-y-12">

        {/* Immersive Discord Card */}
        <div className="cht-relative cht-w-full cht-rounded-[32px] md:cht-rounded-[48px] cht-overflow-hidden cht-shadow-2xl cht-group">
          {/* Background Image/Gradient */}
          <div className="cht-absolute cht-inset-0 cht-bg-[#5865F2]">
            <img
              src="https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=2070&auto=format&fit=crop"
              className="cht-w-full cht-h-full cht-object-cover cht-mix-blend-overlay cht-opacity-40 group-hover:cht-scale-105 cht-transition-transform cht-duration-[2000ms]"
              alt="community-bg"
            />
            <div className="cht-absolute cht-inset-0 cht-bg-gradient-to-t cht-from-black/95 cht-via-black/50 cht-to-black/10 md:cht-from-black/85 md:cht-via-black/20 md:cht-to-transparent"></div>
          </div>

          {/* Content Overlay */}
          <div className="cht-relative cht-z-10 cht-w-full cht-p-6 sm:cht-p-10 md:cht-p-12 cht-flex cht-flex-col cht-justify-end cht-min-h-[380px] md:cht-h-[400px] cht-space-y-6">
            <div className="cht-flex cht-flex-col sm:cht-flex-row sm:cht-items-center cht-gap-4">
              <div className="cht-w-14 cht-h-14 sm:cht-w-16 sm:cht-h-16 cht-bg-white cht-rounded-2xl cht-flex cht-items-center cht-justify-center cht-shadow-2xl cht-shrink-0">
                <svg className="cht-w-8 cht-h-8 sm:cht-w-10 sm:cht-h-10 text-[#5865F2]" viewBox="0 0 127.14 96.36">
                  <path fill="currentColor" d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.06,72.06,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.71,32.65-1.82,56.6.48,80.21a105.73,105.73,0,0,0,32.22,16.15c2.45-3.35,4.63-6.93,6.44-10.74a70.7,70.7,0,0,1-10.19-4.85c.86-.63,1.7-1.28,2.51-1.94a73.48,73.48,0,0,0,64.29,0c.81.66,1.65,1.31,2.51,1.94a71.26,71.26,0,0,1-10.2,4.85c1.8,3.81,4,7.39,6.44,10.74a105.54,105.54,0,0,0,32.25-16.15C129.58,51.87,125,28.26,107.7,8.07ZM42.45,65.69c-6.22,0-11.38-5.71-11.38-12.73S36.14,40.23,42.45,40.23s11.44,5.71,11.44,12.73S48.75,65.69,42.45,65.69Zm42.24,0c-6.22,0-11.38-5.71-11.38-12.73s5.07-12.73,11.38-12.73,11.44,5.71,11.44,12.73S90.91,65.69,84.69,65.69Z" />
                </svg>
              </div>
              <div className="cht-space-y-1">
                <div className="cht-flex cht-items-center cht-gap-2">
                  <div className="cht-w-2 cht-h-2 cht-bg-green-400 cht-rounded-full cht-animate-pulse"></div>
                  <span className="cht-text-green-400 cht-text-xs cht-font-bold cht-uppercase cht-tracking-widest">Live Now</span>
                </div>
                <h2 className="cht-text-2xl sm:cht-text-3xl cht-font-black cht-text-white">Codehub Official Discord</h2>
              </div>
            </div>

            <div className="cht-flex cht-flex-col md:cht-flex-row md:cht-items-center cht-justify-between cht-gap-6 md:cht-gap-8">
              <p className="cht-text-white/80 cht-max-w-xl cht-font-medium cht-leading-relaxed cht-text-sm sm:cht-text-base">
                Connect with 42+ students online right now. Share code, get instant help from mentors, and collaborate on real-world projects.
              </p>
              <Button
                as="a"
                href="https://discord.gg/4frAqrTqA"
                target="_blank"
                rel="noopener noreferrer"
                variant="ghost"
                size="lg"
                className="cht-bg-white cht-text-[#5865F2] hover:cht-bg-white/90 cht-px-8 sm:cht-px-10 cht-w-full md:cht-w-auto cht-shrink-0"
              >
                Enter The Portal
              </Button>
            </div>
          </div>
        </div>

        {/* Quick Links Grid */}
        <div className="cht-grid cht-grid-cols-1 md:cht-grid-cols-3 cht-gap-8 ">
          <FeatureCard
            icon={MessageSquare}
            title="General Chat"
            description="Discuss industry news, tech trends, and career goals with your peers."
            colorClass="cht-bg-[#3e57da]"
            href="https://discord.gg/4frAqrTqA"
          />
          <FeatureCard
            icon={Code2}
            title="Coding Support"
            description="Stuck on a bug? Post your snippets and get help from our senior mentors."
            colorClass="cht-bg-orange-500"
            href="https://discord.gg/4frAqrTqA"
          />
          <FeatureCard
            icon={Users2}
            title="Collaboration"
            description="Find teammates for your next big project or study groups for exams."
            colorClass="cht-bg-purple-600"
            href="https://discord.gg/4frAqrTqA"
          />
        </div>

        {/* Community Guidelines / Trust Section */}
        <section className="cht-bg-white  cht-backdrop-blur-xl cht-p-10 cht-rounded-[40px] cht-border cht-border-white/60 cht-flex cht-flex-col md:cht-flex-row cht-items-center cht-gap-10">
          <div className="cht-flex-1 cht-space-y-6">
            <h3 className="cht-text-2xl cht-font-black cht-text-black cht-flex cht-items-center cht-gap-3">
              <Zap className="cht-text-[#3e57da]" size={24} /> Community Standards
            </h3>
            <div className="cht-grid cht-grid-cols-1 md:cht-grid-cols-2 cht-gap-6">
              {[
                { icon: ShieldCheck, label: "Zero Tolerance for Toxicity" },
                { icon: Globe, label: "Global Network of Developers" },
                { icon: Users2, label: "Dedicated Mentorship" },
                { icon: MessageSquare, label: "Instant Feedback Loop" }
              ].map((item, i) => (
                <div key={i} className="cht-flex cht-items-center cht-gap-3 cht-text-sm cht-font-bold cht-text-gray-600">
                  <div className="cht-w-6 cht-h-6 cht-bg-[#3e57da]/10 cht-rounded-full cht-flex cht-items-center cht-justify-center">
                    <item.icon size={14} className="cht-text-[#3e57da]" />
                  </div>
                  {item.label}
                </div>
              ))}
            </div>
          </div>
          <a
            href="https://discord.gg/4frAqrTqA"
            target="_blank"
            rel="noopener noreferrer"
            className="cht-w-full md:cht-w-72 cht-aspect-square cht-bg-gray-200/30 hover:cht-bg-gray-200/50 cht-border cht-border-transparent hover:cht-border-white/40 cht-rounded-[32px] cht-flex cht-items-center cht-justify-center hover:cht-shadow-xl hover:-cht-translate-y-1 cht-transition-all cht-duration-500 cht-group/qr"
          >
            <img
              src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://discord.gg/4frAqrTqA"
              className="cht-w-40 cht-h-40 cht-opacity-50 group-hover/qr:cht-opacity-80 cht-transition-opacity"
              alt="qr-code"
            />
          </a>
        </section>

      </main>
    </section>
  );
};

export default CommunityHub;
